/** Форматирует номер версии приложения */
export const formatVersion = (value: string): string => {
    const digits = value.replace(/\D/g, '').slice(0, 3);

    return digits.split('').join('.');
};
